export default "__VITE_ASSET__J7lUQSO7__"